import React from "react";

const ActionButton = ({ children, variant = "dark", onClick }) => {
  const isHighlighted = variant === "highlighted";

  const commonStyles = {
    fontFamily: "Montserrat",
    fontSize: "12px",
    lineHeight: "140%",
    fontWeight: 700,
    letterSpacing: "0px",
    minWidth: "160px", // Ensure minimum width to fit content
  };

  const commonClasses = `
    py-3
    px-4
    transition-all 
    duration-300 
    relative 
    whitespace-nowrap
    flex
    items-center
    justify-center
  `;

  if (isHighlighted) {
    return (
      <button
        onClick={onClick}
        style={{
          ...commonStyles,
          background: "linear-gradient(112.38deg, rgba(255, 255, 255, 0.5) -120.84%, rgba(255, 255, 255, 0.1) 79.67%)",
          color: "#DAAA00",
        }}
        className={commonClasses}
      >
        {children}
      </button>
    );
  }

  return (
    <button
      className={`${commonClasses} border border-white ${
        variant === "dark" ? "bg-black text-white hover:bg-gray-800" : "bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 text-yellow-500"
      }`}
      onClick={onClick}
      style={commonStyles}
    >
      {children}
    </button>
  );
};

export default ActionButton;